<template>
    <div class="p-4 position-relative">
        <ValidationObserver ref="infoForm">
            <fieldset class="border p-3 mb-4 rounded">
                <legend class="w-auto px-2 font-weight-bold h6">
                    {{ $t('personal_information') }}
                </legend>
                <b-row>
                    <b-col md="4" class="mb-3">
                        <ValidationProvider
                            name="national_id"
                            :rules="!form.passport_number ? 'required|digits:11' : ''"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('tc_no')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.national_id"
                                    :disabled="!!form.passport_number"
                                    v-mask="'###########'"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider
                            name="passport_number"
                            :rules="!form.national_id ? 'required' : ''"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('passport_number')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.passport_number"
                                    :disabled="!!form.national_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('name')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.name"
                                    class="text-uppercase"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="surname" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('surname')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.surname"
                                    class="text-uppercase"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="gender" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('gender')">
                                <gender-selectbox
                                    v-model="form.gender"
                                    :validateError="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="nationality_code" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('nationality')">
                                <country-selectbox
                                    v-model="form.nationality_code"
                                    valueType="code"
                                    :public="true"
                                    :validateError="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="education_status" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('education_status')">
                                <parameter-selectbox
                                    :public="true"
                                    code="education_statuses"
                                    :validateError="errors[0]"
                                    sort="rank"
                                    v-model="form.education_status">
                                </parameter-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="father_name" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('father_name')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.father_name"
                                    class="text-uppercase"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="mother_name" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('mother_name')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.mother_name"
                                    class="text-uppercase"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="birth_place" rules="" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('birthplace')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.birth_place"
                                    class="text-uppercase"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="last_school" rules="" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('last_school')">
                                <university-selectbox :public="true" v-model="form.last_school"
                                                      :validate-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </fieldset>

            <fieldset class="border p-3 mb-4 rounded">
                <legend class="w-auto px-2 font-weight-bold h6">
                    {{ $t('contact_information') }}
                </legend>

                <b-row>
                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="phone" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('telephone')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.phone"
                                    v-mask="'(5##)-###-####'"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="email" rules="required|email" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('email_address')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.email"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="city_id" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('city')">
                                <city-selectbox
                                    v-model="form.city_id"
                                    :validateError="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="4" class="mb-3">
                        <ValidationProvider name="district_id" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('district')">
                                <district-outline-selectbox
                                    :city_id="form.city_id"
                                    v-model="form.district_id"
                                    :validateError="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="12" class="mb-3">
                        <ValidationProvider name="address" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('address_2')">
                                <b-form-textarea
                                    rows="3"
                                    v-model="form.address"
                                    class="text-uppercase"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </fieldset>

            <div class="text-center">
                <b-button
                    variant="primary"
                    class="px-5"
                    @click="submitAndNext"
                    :disabled="loading"
                >
                    <b-spinner small v-if="loading" class="mr-2" />
                    {{ $t('next') }}
                </b-button>
            </div>

        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VisitorStudentApplicationServices from "@/services/VisitorStudentApplicationServices";
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox";
import CitySelectbox from '@/components/interactive-fields/CitySelectbox';
import SchoolSelectbox from "@/components/interactive-fields/SchoolSelectbox.vue";

export default {
    components: {
        SchoolSelectbox,
        ValidationObserver,
        ValidationProvider,
        DistrictOutlineSelectbox,
        CitySelectbox
    },
    props: {
        userData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            form: {
                name: null,
                surname: null,
                gender: null,
                nationality_code: 'TR',
                phone: null,
                email: null,
                city_id: null,
                district_id: null,
                address: null,
                education_status: null,
                father_name: null,
                mother_name: null,
                birth_place: null,
                last_school: null
            },
        };
    },
    watch: {
        userData: {
            immediate: true,
            handler(val) {
                if (val && Object.keys(val).length > 0) {
                    this.form = { ...this.form, ...val };
                }
            }
        }
    },
    methods: {
        async submitAndNext() {
            const isValid = await this.$refs.infoForm.validate();
            if (!isValid) return;

            this.loading = true;
            try {
                const credentials = this.$store.getters['VisitorStudentApplicationStore/getCredentials'];
                const payload = { ...this.form, ...credentials };

                if (payload.phone) {
                    payload.phone = payload.phone.replace(/\D/g, '');
                }

                const response = await VisitorStudentApplicationServices.updateInformation(payload);
                this.$emit('next', this.form);
                const message = response.data?.message || response.data?.data?.message;
                if (message) this.$toast.success(this.$t('api.' + message));
            } catch (error) {
                this.showErrors(error, this.$refs.infoForm);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
